import { authorize, deleteRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function deleteRSSFeedAPI(feedId) {
  const url = `${AWS_API_URL}/rss-feeds/${feedId}`;
  return deleteRequest(url, await authorize());
}
